import type { ReactNode } from 'react';

import { AveragePlayerScore } from '@sorare/core/src/__generated__/globalTypes';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { Cost } from '@sorare/core/src/components/player/Cost';

type Props = {
  variant: AveragePlayerScore;
};

const CostComponent = ({
  children,
  inverted,
  noBorder,
}: {
  children: ReactNode;
  inverted?: boolean;
  noBorder?: boolean;
}) => (
  <Cost
    size={3}
    color="var(--c-score-high)"
    score={
      <LabelS bold color={inverted ? 'var(--c-score-high)' : 'var(--c-black)'}>
        {children}
      </LabelS>
    }
    inverted={inverted}
    noBorder={noBorder}
  />
);

export const AveragePlayerScoreIcon = ({ variant }: Props) => {
  switch (variant) {
    case AveragePlayerScore.SEASON_AVERAGE_SCORE:
      return <CostComponent>S</CostComponent>;
    case AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE:
      return <CostComponent inverted>L5</CostComponent>;
    case AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE:
      return <CostComponent>L10</CostComponent>;
    case AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE:
      return (
        <CostComponent inverted noBorder>
          L40
        </CostComponent>
      );
    case AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE:
    default:
      return <CostComponent>L15</CostComponent>;
  }
};
